import {
  API_GET_ALL_FUNCTIONNALITIES,
  HEADERS,
} from "@/components/globalConfig/globalConstConfig";
import axios from "axios";

// Liste des fonctionnalités (permissions). Lève une erreur lisible en cas d'échec :
// c'est à l'écran appelant de l'afficher.
export const getPermissionApi = async (body, token) => {
  let response;
  try {
    response = await axios.post(API_GET_ALL_FUNCTIONNALITIES, body, { headers: HEADERS(token) });
  } catch (e) {
    throw new Error((e && e.message) || "Erreur réseau lors du chargement des permissions.");
  }
  if (response.status == 200 && response.data.status.code == 800) {
    return response.data.items || [];
  }
  throw new Error(
    (response.data && response.data.status && response.data.status.message) ||
      "Impossible de charger les permissions."
  );
};
